module.exports = __webpack_public_path__ + "static/media/att_28.59925620.jpg";